export const dsktpExitTiming = 0.65;